<template>
  <div class="free-num">
    <div class="text">送{{ num }}次</div>
    <svg width="16" height="35" viewBox="0 0 16 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 -3H16V33C16 33.824 15.0592 34.2944 14.4 33.8L9.2 29.9C8.48889 29.3667 7.51111 29.3667 6.8 29.9L1.6 33.8C0.940764 34.2944 0 33.824 0 33V-3Z" :fill="bg_color"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    bg_color: {
      type: String,
      default: '#BD3F32'
    },
    num: ''
  }
}
</script>

<style lang="less" scoped>
.free-num {
  width: 16px;
  height: 38px;
  position: absolute;
  top: 0;
  right: 23px;;
  .text {
    font-size: 12px;
    color: #FFF;
    word-wrap: break-word;
    word-break: break-all;
    z-index: 1;
    transform-origin: center top;
    font-weight: 600;
    line-height: 12px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 2px) scale(.75);
    top: 0;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
}
</style>